import { Breadcrumbs } from '@saucelabs/ds-breadcrumbs/lib';
import { Typography } from '@saucelabs/ds-typography/lib';
import React from 'react';
import { List } from 'immutable';
import { useFlags } from '@saucelabs/sl-util-launchdarkly';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';

import { CreditsRatesTable } from '../components/CreditsRatesTable';
import { HowCreditsWorkFAQ } from '../components/HowCreditsWorkFAQ';
import SideNavigationContainer from '../components/SideNavigation';
import { ROUTE_PARENT_SECTION } from '../constants';
import { trackEvent, EVENTS } from '../tracking';
import Subscription from '../records/Subscription';
import { selectors, actions } from '../ducks/subscriptions';

const crumbList = [
  {
    name: 'Subscription and Billing',
    url: `/${ROUTE_PARENT_SECTION}`,
    onClick: () => trackEvent(EVENTS.PLANS_NAVIGATE_BACK, { checkout_step: 'overview' }),
  },
  { name: 'About Credits' },
];

export interface CreditsFAQContainerProps {
  subscriptions: List<Subscription>,
  fetchSubscriptions: () => void
}

const mapStateToProps = (state) => {
  const usageSubscriptions = selectors.getSubscriptionsSelector(state);

  return {
    subscriptions: usageSubscriptions,
  };
};

const mapDispatchToProps = {
  fetchSubscriptions: actions.fetchSubscriptions,
};

export const CreditsFrequentlyAskedQuestions: React.FC<CreditsFAQContainerProps> = ({
  subscriptions = List(),
  fetchSubscriptions,
}) => {
  const initialized = subscriptions?.size > 0;
  React.useEffect(() => {
    if (!initialized) {
      fetchSubscriptions();
    }
  }, [initialized]);

  // If user is not in usage-based billing, redirect to /billing
  const flags = useFlags();
  const subscription = subscriptions.find((sub) => sub?.plan.isUsage() || false);
  const isUsageBasedBilling = flags.webUiUsageBasedBilling ||
    subscription?.plan?.isUsage();

  return isUsageBasedBilling ? (
    <>
      <Breadcrumbs list={crumbList}>
        <SideNavigationContainer showCreditsFAQ />
      </Breadcrumbs>
      <div
        className="bg-gray"
        data-qa="credits-faq-view"
      >
        <Typography
          className="text-high-emphasis text-center m-0 mt-5"
          disableSpacing
          variant="heading-1"
        >
          About Credits
        </Typography>
      </div>
      <div className="mx-auto max-w-76 px-2">
        <Typography
          className="text-high-emphasis mt-3 mb-0 text-center"
          disableSpacing
          variant="heading-3"
        >
          Rates for automated + manual tests
        </Typography>
        <Typography
          className="text-center mt-2 mb-2"
          disableSpacing
          variant="body-large"
        >
          Credits are applied automatically when you run tests
        </Typography>
        <CreditsRatesTable />
      </div>
      <div className="mb-14">
        <HowCreditsWorkFAQ />
      </div>
    </>
  ) : (
    <Redirect to="/billing" />
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CreditsFrequentlyAskedQuestions);
